module.exports = __webpack_public_path__ + "img/customer-service.f2a303c.webp";